<div [hidden]="loggingIn || fetchingAuthRealm" class="wm-login-sso-form">
  <img class="wm-login-sso-logo" src="/assets/img/webmate_Redesign_Logo_RGB_vereinfachung_positiv.svg">
  <form #inputForm="ngForm">
    <div class="wm-login-sso-error" data-testing-id="login-errorfield" [hidden]="!loginFailure">There was an error while logging in. Please check your credentials and try again</div>
    <div class="wm-login-sso-username">
      <div class="wm-l-sso-login-form-field">
        <input [(ngModel)]="email" class="user-input" email name="email" type="text" tabindex="1" data-testing-id="login-userfield">
        <span class="label" [ngClass]="{'outside': email !== ''}">Email address</span>
      </div>
    </div>
    <button pButton class="wm-login-sso-submitbutton" type="submit" [disabled]="checkForm()" (click)="submitLogin()" data-testing-id="login-submit-button">SSO Sign in</button>
  </form>
</div>
<div [hidden]="!(loggingIn || fetchingAuthRealm)">
  <div class="wm-login-sso-spinner-wrapper">
    @if (!migrateUser) {
      <div class="wm-login-sso-spinner-msg">Waiting for Single-Sign-On...</div>
    }
    @if (migrateUser) {
      <div class="wm-login-sso-spinner-msg">Setting-up your SSO user...</div>
    }
    <p-progressSpinner class="wm-login-sso-spinner"></p-progressSpinner>
  </div>
</div>
